<div class="evaluation-layout">
  <nav class="evaluation-nav">
    <mat-nav-list>
      <ng-container *ngIf="isAdmin$ | async; else producerNav">
        <a mat-list-item routerLink="season" routerLinkActive="active-link">
          <mat-icon matListItemIcon>table_chart</mat-icon>
          <span matListItemTitle>Season</span>
        </a>
        <a mat-list-item routerLink="criteria" routerLinkActive="active-link">
          <mat-icon matListItemIcon>grid_on</mat-icon>
          <span matListItemTitle>Criteria</span>
        </a>
        <a mat-list-item routerLink="review" routerLinkActive="active-link">
          <mat-icon matListItemIcon>rule</mat-icon>
          <span matListItemTitle>Review queue</span>
        </a>
      </ng-container>
      <ng-template #producerNav>
        <a mat-list-item routerLink="my-games" routerLinkActive="active-link">
          <mat-icon matListItemIcon>fact_check</mat-icon>
          <span matListItemTitle>My broadcasts</span>
        </a>
      </ng-template>
      <a mat-list-item routerLink="guide" routerLinkActive="active-link">
        <mat-icon matListItemIcon>help_outline</mat-icon>
        <span matListItemTitle>How it works</span>
      </a>
    </mat-nav-list>
    <div class="season-picker" *ngIf="(seasons$ | async)?.length as count">
      <!-- A single season needs no picker; a second one makes reaching the
           first again the whole point, because that is where invoicing and
           any dispute about an agreed amount still live. -->
      <div class="season-badge" *ngIf="count === 1">Season {{ current }}</div>
      <mat-form-field appearance="outline" class="season-field" *ngIf="count > 1">
        <mat-label>Season</mat-label>
        <mat-select [ngModel]="current" (ngModelChange)="chooseSeason($event)">
          <mat-option *ngFor="let season of seasons$ | async" [value]="season">
            {{ season }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="past-season" *ngIf="!onLatestSeason">
        <mat-icon>history</mat-icon>
        Not the current season
      </div>
    </div>
  </nav>
  <main class="evaluation-content">
    <router-outlet></router-outlet>
  </main>
</div>
